"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const NestedHobbyFieldset_1 = __importDefault(require("../fieldsets/NestedHobbyFieldset"));
const FieldControls_1 = __importDefault(require("../controls/FieldControls"));
const MaterialTextField_1 = __importDefault(require("../inputs/MaterialTextField"));
exports.default = (0, mobx_react_1.observer)(({ member }) => (react_1.default.createElement("fieldset", { className: "tc pa3" },
    react_1.default.createElement(MaterialTextField_1.default, { field: member.$('firstname') }),
    react_1.default.createElement(MaterialTextField_1.default, { field: member.$('lastname') }),
    react_1.default.createElement("br", null),
    react_1.default.createElement("span", null,
        react_1.default.createElement(FieldControls_1.default, { field: member, 
            // labels={false}
            controls: {
                onDel: true,
                onClear: true,
                onReset: true,
            } })),
    react_1.default.createElement("br", null),
    member.has('hobbies') &&
        react_1.default.createElement(NestedHobbyFieldset_1.default, { hobbies: member.$('hobbies') }),
    react_1.default.createElement(FieldControls_1.default, { field: member, controls: { onSubmit: true } }))));
